import LinksActions from '../../../../actions/LinksActions';
import query from '../../../../helpers/query';
import { removeParams } from '../helpers';
import CustomNotify from "../../../Notify";
import PromoCodeActions from "../../../../actions/PromoCodeActions";

const actions = {
    getLinks(state) {
        const params = {
            ...query.parseToSend(state),
            ...removeParams(),
            q: state.nameLink,
            skip_containers: 1,
            offer_ids: Number(state.offerId) || state.offer_ids
        };

        LinksActions.getListLinks(params);
    },

    saveLinkPresets(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;
        let linkParams = state.link.params;

        if(typeof linkParams === "string") {
            linkParams = JSON.parse(state.link.params);
        }

        let params = {
            publisher_id: state.publisherId,
            offer_id: state.link.offer.id,
            link_id: state.linkId,
            params: JSON.stringify(linkParams)
        };

        LinksActions.saveLinkPresets(params).then(() => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    },

    savePromoCode(state, t, onSuccess, onError) {
        const notyNames = t.notyMessages;
        let linkParams = state.link.params;

        if(typeof linkParams === "string") {
            linkParams = JSON.parse(state.link.params);
        }

        let params = {
            goal_id: state.goal_id,
            publisher_id: state.publisherId,
            offer_id: state.link.offer.id,
            link_id: state.linkId,
            params: JSON.stringify(linkParams)
        };

        PromoCodeActions.savePromoCode(params).then(() => {
            CustomNotify(notyNames.update);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    },

    deletePromoCode(id, t, onSuccess, onError) {
        const notyNames = t.notyMessages;

        let params = {
            id: id
        };

        PromoCodeActions.deletePromoCode(params).then(() => {
            CustomNotify(notyNames.delete);
            onSuccess && onSuccess();
        }).catch(err => {
            onError && onError(err.error.invalid_parameters);
        });
    }
};

export default actions;
